<!--
 * @Author: Lemon C
 * @Date: 2024-05-14 11:17:12
 * @LastEditTime: 2024-12-14 14:58:47
-->
<template>
    <div class="sup-bady">
        <DocsTypeSwitch class="top-type-switch" :currId="curr_switch_type" :switch_type="1" :title_name="'FAQ'" :needSerarch="true"> </DocsTypeSwitch>
        <div class="docs-page">
            <DocsTree class="docs-tree" :request_gourp="$globalObj.group.faq" :share_url_data="shareData" :tree_node_callback="tree_node_callback">
            </DocsTree>
            <FAQComp class="docs-content" ref="ref_faq_comp" :comp_tree_node_id="eltree_sel_data.id" :comp_sel_faq_list_id="sel_faq_list_id"></FAQComp>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onBeforeMount, onMounted, getCurrentInstance, nextTick } from 'vue';
import DocsTypeSwitch from '@/components/Docs/DocsTypeSwitch.vue';
import DocsTree from '@/components/Tree/DocsTree.vue';
import FAQComp from '@/components/FAQ/FAQComp.vue';

import { useRouterStore } from '@/stores/router';
import { useMessageStore } from '../../stores/message';

const message_store = useMessageStore();
const router_store = useRouterStore();
const { proxy } = getCurrentInstance();

const curr_switch_type = ref(proxy.$globalObj.docs_switch.faq); //当前文档类型
const ref_faq_comp = ref(null);
const shareData = ref({}); //分享链接数据
const eltree_sel_data = ref({}); // 目录树选中节点
const sel_faq_list_id = ref(''); // 列表选择id

onBeforeMount(() => {
    let queryDate = proxy.$route.query;
    if (queryDate && queryDate.shareType && queryDate.shareType == 1) {
        shareData.value = queryDate;
    }
    if (queryDate && queryDate.docId && queryDate.docId.length > 0) {
        sel_faq_list_id.value = queryDate.docId;
    }
    console.log('分享数据 -- ', queryDate);
});

// MARK Tree  节点点击
const tree_node_callback = (data, treeList) => {
    eltree_sel_data.value = data;
    nextTick(()=>{
        message_store.sendMessage(message_store.M_E_TREE_LIST_UPDATE, { treeList: treeList });
    })
    nextTick(() => {
        ref_faq_comp.value.$refs.ref_breadcrumb.update_data(data.id, treeList);
    });

    let queryDate = proxy.$route.query;
    if (!(queryDate && queryDate.shareType && queryDate.shareType == 1 && queryDate.treeId && queryDate.treeId == data.id)) {
        router_store.configBrowserAddressRoute({ shareType: 1, treeId: data.id });
    }
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-bady {
    height: 100%;
    flex-direction: column;
    overflow: hidden;
    background-color: var(--color-main-light-bg-white);

    .top-type-switch {
        position: absolute;
        top: 0;
        left: 0;
        z-index: var(--type-switch-z-index);
    }

    .docs-page {
        position: relative;
        margin-top: 80px;
        width: 100%;
        height: calc(100% - 80px);
        background-color: var(--color-main-light-bg-white);
        display: flex;
        overflow: hidden;

        .docs-tree {
            width: 23%;
        }

        .docs-content {
            height: 100%;
            flex: 1;
        }
    }
}
</style>
